import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "12 6 12 12 9.5 16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Clock7";
const Clock7 = memo(themed(Icon));
export {
  Clock7
};
//# sourceMappingURL=clock-7.js.map
